import { TokenExpiredComponent } from '@qima-labs/app/shared/services/token-checker-services/shared/components/token-expired/token-expired.component';
import { DialogService } from '@qsp-ui-library/components/modal/shared/services/dialog.service';
import { EStorageKeys } from '@qsp-ui-library/models/enums/storage-keys.enum';
import { AppAuthenticationService } from '@qsp-ui-library/services/user-services/app-authentication/app-authentication.service';
import { Injectable } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { CookieService } from 'ngx-cookie';
import { Subscription, tap, timer } from 'rxjs';

@UntilDestroy()
@Injectable()
export class TokenCheckerService {
  private _timerSubscription: Subscription | undefined = undefined;

  public constructor(
    private readonly _cookieService: CookieService,
    private readonly _dialogService: DialogService,
    private readonly _appAuthenticationService: AppAuthenticationService
  ) {
    this._appAuthenticationService.refreshTokenExpire$.pipe(untilDestroyed(this)).subscribe((): void => {
      this._timerSubscription?.unsubscribe();
      this.startTokenChecker();
    });
  }

  /*
   * SP-21200 : it need to popup a dialog to tell user that session is expired
   * for the requirement implement ,it need to use timer
   * */
  public startTokenChecker(): void {
    const refreshTokenExpire = parseInt(this._cookieService.get(EStorageKeys.REFRESH_TOKEN_EXPIRE) || '0', 10);
    const timeDifferenceInSeconds = Math.floor(refreshTokenExpire - Date.now() / 1000);
    const delayInSeconds = timeDifferenceInSeconds + 1; // plus 1 second to make sure the token is expired
    const delayInMilliseconds = delayInSeconds * 1000;

    if (delayInSeconds > 0) {
      this._timerSubscription = timer(delayInMilliseconds).subscribe((): void => {
        this._checkTokenExpiration();
      });
    }
  }

  public openSessionCheckDialog(): void {
    this._dialogService
      .open(TokenExpiredComponent)
      .afterClosed$()
      .pipe(
        tap((): void => {
          this._timerSubscription?.unsubscribe();
        }),
        untilDestroyed(this)
      )
      .subscribe();
  }

  private _checkTokenExpiration(): void {
    const refreshTokenExpire = this._cookieService.get(EStorageKeys.REFRESH_TOKEN_EXPIRE);

    if (refreshTokenExpire) {
      const expireTime = parseInt(refreshTokenExpire || '0', 10);
      const currentTime = Math.floor(Date.now() / 1000);

      if (currentTime >= expireTime) {
        this.openSessionCheckDialog();
      }
    }
  }
}
